import type { SiteMembersClientSpecEntry } from '@wix/thunderbolt-ssr-api'
import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api-types'
import type { SiteMembersWixCodeSdkSiteConfig } from '../types'

const siteMembersWixCodeSdkSiteConfig: SiteConfigFn<SiteMembersWixCodeSdkSiteConfig> = ({ api }) => {
	const shouldLoad = api.features.isActive('platform')

	if (!shouldLoad) {
		return {
			shouldLoadSiteFeature: false,
			shouldLoadSiteConfig: false,
			siteConfig: null,
		}
	}

	const clientSpecMap = api.rendererModel.getClientSpecMap()
	const smApp = (Object.values(clientSpecMap).find((app) => app.type === 'sitemembers') ||
		{}) as SiteMembersClientSpecEntry

	const siteConfig: SiteMembersWixCodeSdkSiteConfig = {
		isPreviewMode: false,
		isEditMode: false,
		smToken: smApp.smtoken || '',
		smcollectionId: smApp.smcollectionId,
	}

	return {
		shouldLoadSiteFeature: true,
		shouldLoadSiteConfig: true,
		siteConfig,
	}
}

const name = 'siteMembersWixCodeSdk'

export const config = { site: siteMembersWixCodeSdkSiteConfig, reactNativeSite: siteMembersWixCodeSdkSiteConfig, name }
